import config from '../../config'
import { buildGetQuery } from '../../util'

import { IGetRequestObject } from '../../interfaces'
import { IAirportLite } from '../../interfaces'

type Params = {
  portalKey: string
}

const request = (params: Params): IGetRequestObject => {
  const { portalKey } = params

  return {
    method: 'get',
    url: `${config.baseUrl}/sms/SafetyReport/${portalKey}`,
  }
}

const useSafetyReportAirportByPortalKey = buildGetQuery<Params, undefined, IAirportLite | undefined>({
  getRequest: request,
  getQueryKey: params => ['safety-report-airport-by-portal-key', params.portalKey],
})

export default useSafetyReportAirportByPortalKey
